export interface Category {
  id: number;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 1,
    name: '国产剧',
    slug: 'guochan-ju',
    description: '精选优质国产电视剧，涵盖古装、现代、悬疑、都市、年代等多元题材，持续更新热门剧集。',
    icon: 'ri-tv-line',
    articleCount: 24,
  },
  {
    id: 2,
    name: '国产电影',
    slug: 'guochan-dianying',
    description: '汇聚最新国产电影佳作，从商业大片到文艺精品，为您呈现华语电影的独特魅力。',
    icon: 'ri-film-line',
    articleCount: 18,
  },
  {
    id: 3,
    name: '国产综艺',
    slug: 'guochan-zongyi',
    description: '热门国产综艺节目一网打尽，音乐竞演、户外真人秀、脱口秀、文化类节目精彩纷呈。',
    icon: 'ri-live-line',
    articleCount: 15,
  },
  {
    id: 4,
    name: '国产动漫',
    slug: 'guochan-dongman',
    description: '国产动漫崛起之作，玄幻、武侠、科幻、治愈等多种风格，见证国漫的蓬勃发展。',
    icon: 'ri-rocket-line',
    articleCount: 20,
  },
  {
    id: 5,
    name: '国产纪录片',
    slug: 'guochan-jilupian',
    description: '高品质国产纪录片，聚焦自然、人文、历史、科技等领域，用镜头讲述真实的中国故事。',
    icon: 'ri-camera-line',
    articleCount: 12,
  },
];